import React, { useState } from "react";
import "./Metal3DPrinting.css";
import HeroImg from "../../../Gallery/ServicesImages/unnamed.jpg";

// card images
import Img1 from "../../../Gallery/ServicesImages/AM/SLA.png";
import Img2 from "../../../Gallery/ServicesImages/AM/SLS.png";
import Img3 from "../../../Gallery/ServicesImages/AM/MULTI JET FUSION.png";
import Img4 from "../../../Gallery/ServicesImages/AM/DMLS.png";
import Img5 from "../../../Gallery/ServicesImages/AM/FDM.png";

// modal images (machine pictures)
import SLAimg from "../../../Gallery/ServicesImages/AM/SLA.png";
import SLSimg from "../../../Gallery/ServicesImages/AM/SLS.png";
import Multifusion from "../../../Gallery/ServicesImages/AM/MULTI JET FUSION.png";
import DMLSimg from "../../../Gallery/ServicesImages/AM/DMLS.png";
import FMDimg from "../../../Gallery/ServicesImages/AM/FDM.png";

function Metal3DPrinting() {
  const [activeModal, setActiveModal] = useState(null);

  const cards = [
    {
      title: "SLA",
      img: Img1,
      modalImg: SLAimg,
      description:
        "SLA uses a UV laser to cure liquid resin layer by layer, producing detailed and smooth 3D-printed parts. It is ideal for high-precision prototypes and visual models.",
      advantages: [
        "High accuracy and smooth finish",
        "Ideal for detailed prototypes",
        "Great for visual and concept models",
      ],
      applications: [
        "Design prototypes",
        "Miniature models",
        "Medical visualization models",
      ],
    },
    {
      title: "SLS",
      img: Img2,
      modalImg: SLSimg,
      description:
        "SLS uses a laser to sinter powdered material into solid structures without requiring support structures. Strong and functional parts are produced.",
      advantages: [
        "Durable and functional parts",
        "No support structures needed",
        "Good for complex geometry",
      ],
      applications: [
        "Functional prototypes",
        "Automotive components",
        "Lightweight engineering parts",
      ],
    },
    {
      title: "MULTI JET FUSION",
      img: Img3,
      modalImg: Multifusion,
      description:
        "MJF uses fusing and detailing agents combined with heat to create strong and accurate parts. It is known for fast production and high detail.",
      advantages: [
        "Fast production speed",
        "Strong functional parts",
        "High dimensional accuracy",
      ],
      applications: [
        "Batch manufacturing",
        "Engineering components",
        "Consumer product housings",
      ],
    },
    {
      title: "DMLS (Direct Metal Laser Sintering)",
      img: Img4,
      modalImg: DMLSimg,
      description:
        "DMLS melts fine metal powder using a high-powered laser, creating dense and strong metal components ideal for industrial applications.",
      advantages: [
        "High strength metal parts",
        "Suitable for complex structures",
        "Reduced material waste",
      ],
      applications: [
        "Aerospace parts",
        "Medical implants",
        "Industrial tooling",
      ],
    },
    {
      title: "FDM (Fused Deposition Modeling)",
      img: Img5,
      modalImg: FMDimg,
      description:
        "FDM builds parts by extruding melted thermoplastic filament layer by layer. It is a cost-effective method for prototypes and functional parts.",
      advantages: [
        "Cost-effective printing",
        "Wide choice of materials",
        "Great for functional parts",
      ],
      applications: [
        "Prototyping",
        "Tooling and jigs",
        "Educational models",
      ],
    },
  ];

  return (
    <div className="metal3d_wrapper">

      {/* HERO */}
      <div className="metal_hero">
        <img src={HeroImg} alt="Metal 3D Printing" className="hero_img" />
        <div className="hero_content">
          <h1>3D Printing</h1>
          <p>Industrial Additive Manufacturing Technologies</p>
        </div>
      </div>

      {/* Intro */}
      <div className="intro_section">
        <div className="intro_title_wrapper">
          <h1 className="intro_title">What Is Additive Manufacturing?</h1>
          <div className="title_circle"></div>
        </div>

        <p className="intro_desc">
        Additive Manufacturing (3D Printing) is a layer-by-layer production process that creates physical parts directly from digital CAD models. It allows fast prototyping, complex geometries, and low-volume production without the need for molds or tooling.
        </p>
      </div>

      {/* CARD GRID */}
      <div className="card_row">
        {cards.map((card, index) => (
          <div
            key={index}
            className="info_card"
            onClick={() => setActiveModal(index)}
          >
            <img src={card.img} alt={card.title} />
            <h3>{card.title}</h3>
          </div>
        ))}
      </div>

      {/* MODAL */}
      {activeModal !== null && (
        <div className="modal_overlay" onClick={() => setActiveModal(null)}>
          <div className="modal_container small_modal" onClick={(e) => e.stopPropagation()}>
            
            {/* Close Button */}
            <button className="modal_close" onClick={() => setActiveModal(null)}>
              ✕
            </button>

            <div className="modal_flex">
              <img
                src={cards[activeModal].modalImg}
                className="modal_machine_img"
                alt="machine"
              />

              <div className="modal_text">
                <h2>{cards[activeModal].title}</h2>
                <p>{cards[activeModal].description}</p>

                <div className="modal_lists">

                  <div>
                    <h3>Advantages</h3>
                    <ul>
                      {cards[activeModal].advantages.map((adv, i) => (
                        <li key={i}>{adv}</li>
                      ))}
                    </ul>
                  </div>

                  <div>
                    <h3>Applications</h3>
                    <ul>
                      {cards[activeModal].applications.map((app, i) => (
                        <li key={i}>{app}</li>
                      ))}
                    </ul>
                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>
      )}

      {/* MATERIALS SECTION */}
      <div className="materials_section">

        <div className="materials_title_wrapper">
          <h1 className="materials_title">Materials Used In AM</h1>
          <div className="materials_circle"></div>
        </div>

        <div className="materials_grid">

          <div className="material_block">
            <h2>RESINS</h2>
            <p>
              Photopolymer resins used in SLA deliver smooth, highly detailed parts suitable for precision models and visual prototypes.
            </p>
          </div>

          <div className="material_block">
            <h2>NYLON</h2>
            <p>
              Nylon powder used in SLS provides flexibility, strength, and durability, making it ideal for functional engineering parts.
            </p>
          </div>

          <div className="material_block">
            <h2>METAL</h2>
            <p>
              Metal powders used in DMLS create high-strength, heat-resistant components for demanding industrial applications.
            </p>
          </div>

        </div>
      </div>

    </div>
  );
}

export default Metal3DPrinting;
